module.exports = __webpack_public_path__ + "img/NOLCardGapDetailed-min.035b6552.png";